const normalizeRelativeUrl = (value: unknown) => {
    if (typeof value !== 'string') {
        return '';
    }

    const trimmed = value.trim();
    if (!trimmed) {
        return '';
    }

    if (/^(https?:\/\/|\/\/|#)/i.test(trimmed)) {
        return trimmed;
    }

    return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
};

export const normalizeTemplateItem = (item: any) => {
    if (!item || typeof item !== 'object') {
        return item;
    }

    const url = normalizeRelativeUrl(item.url || item.category_url || item.link || item.read_more_url);
    const image = item.image || item.category_image || item.icon || '';

    return {
        ...item,
        name: item.name || item.category_name || item.subcategory_name || item.merchant_name || item.offer_title || item.blog_title || '',
        store_name: item.store_name || item.merchant_name || item.name || '',
        merchant_name: item.merchant_name || item.store_name || item.name || '',
        merchant_logo: item.merchant_logo || item.logo || item.image || item.category_image || '',
        // No `|| item.slug` fallback: a merchant slug ("amazfit.com") is not a URL,
        // and emitting it here produced /amazfit.com instead of /store/amazfit.com.
        // Left empty, resolveCustomThemeHref falls through to buildMerchantHref,
        // which prefixes the company's store_slug from context. The nested
        // merchant.website_url/url ARE real absolute URLs (not slugs), so those
        // are safe to surface directly — some sources (offer cards' nested
        // `item.merchant`) only carry the merchant's URL there, never flattened.
        merchant_url: item.merchant_url || item.url || item.category_url || item.link || item.merchant?.website_url || item.merchant?.url || '',
        slug: item.slug || item.unique_id || '',
        unique_id: item.unique_id || item.slug || '',
        offer_title: item.offer_title || item.title || item.name || '',
        coupon_code: item.coupon_code || item.code || '',
        product_image: item.product_image || item.image || '',
        blog_title: item.blog_title || item.title || item.name || '',
        category_name: item.category_name || item.name || '',
        subcategory_name: item.subcategory_name || item.name || '',
        category_url: item.category_url || url || '#',
        url: url || item.url || '#',
        link: item.link || url || '#',
        read_more_url: item.read_more_url || url || '#',
        category_image: item.category_image || image,
        image,
        slide_image: item.slide_image || image,
        slide_title: item.slide_title || item.text || item.name || item.category_name || item.offer_title || '',
        child: Array.isArray(item.child) ? item.child.map(normalizeTemplateItem) : [],
    };
};
